module.exports = __webpack_public_path__ + "img/twitter.52e0262b.png";